//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Die.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"CutoutLength",0,"Expression",0],[1,"CutoutRadius",0,"Expression",0],[1,"Distance",0,"Expression",0],[0,"DistanceTolerance",1,0],[1,"DividingCurves",0,"ScCollector",0],[1,"Faces",0,"ScCollector",0],[0,"Limits",0,"Die.DieLimitsBuilder",0],[1,"Openings",0,"ScCollector",0],[0,"Output",1,0],[1,"ShelfLength",0,"Expression",0],[0,"ShelfPoint1",1,"Point",0],[0,"ShelfPoint2",1,"Point",0],[1,"ShelfRadius",0,"Expression",0],[0,"Type",1,0]],[[["filterNoise"],"FindOpenings",{},1,0],[["object_array_count","object_array","path"],"CreatePathFromOpening",{},0,0]],[]];
SPLM.Features.PatchOpeningsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PatchOpeningsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PatchOpeningsBuilder.Types = Object.freeze({
    "Quilted" : "Quilted", "NSided" : "NSided", "Mesh" : "Mesh", "ByDeletingEdges" : "ByDeletingEdges", "Extension" : "Extension", "Notch" : "Notch", "Joggle" : "Joggle", "MoldWizard" : "MoldWizard", "BySuppression" : "BySuppression"});

SPLM.Features.PatchOpeningsBuilder.OutputTypes = Object.freeze({
    "SingleFeature" : "SingleFeature", "MultipleFeatures" : "MultipleFeatures", "Sew" : "Sew"});

export default SPLM;